import locator from 'utils/locator';
import { findRouteMatch } from 'route-data/find-route-match';

export const getProductFindingMethod = (): string | undefined => {
  return findRouteMatch(locator.pathname)?.analyticsName;
};
